import { render, staticRenderFns } from "./M-list.vue?vue&type=template&id=5485e954&scoped=true&"
import script from "./M-list.vue?vue&type=script&lang=js&"
export * from "./M-list.vue?vue&type=script&lang=js&"
import style0 from "./M-list.vue?vue&type=style&index=0&id=5485e954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5485e954",
  null
  
)

export default component.exports